import {config, dom, library} from '@fortawesome/fontawesome-svg-core';
import {faChevronRight, faChevronLeft, faExternalLinkAlt, faTag,faMapMarkerAlt} from '@fortawesome/free-solid-svg-icons';
import {faComments, faClock} from '@fortawesome/free-regular-svg-icons';

export default () => {
    config.showMissingIcons = false;
    library.add(faChevronRight, faChevronLeft, faExternalLinkAlt, faTag, faClock,faMapMarkerAlt);
    dom.i2svg();
}
